import React, { FC } from "react";
import { FormControl, MenuItem } from "@material-ui/core";
import Dropdown from "../../shared/components/dropdown";
import { PollingAddress } from "../../../models/pollingAddress";
import { NewCaseAttachment } from "../../../models/newCase";
import AddressesInput from "../../shared/components/addressesInput";
import { useTeamQContext } from "../../../context/teamQContextProvider";
import { convertToSelectOptions } from "../../../models/staticData";

type Props = {
  pollingAddresses: PollingAddress[],
  state: {
    pollingAddressId: string;
    classificationId: string;
    toAddresses: string[];
    ccAddresses: string[];
    subject: string;
    message: string;
    attachments: NewCaseAttachment[];
  },
  setState: {
    setPollingAddressId: (pollingAddressId: string) => void;
    setClassificationId: (classification: string) => void;
    setToAddresses: (toAddresses: string[]) => void;
    setCcAddresses: (ccAddresses: string[]) => void;
    setSubject: (subject: string) => void;
    setMessage: (message: string) => void;
    openEmailAttachments: ()=>void;
  }
};

export const NewCaseForm: FC<Props> = ({
  pollingAddresses, 
  state: {
    classificationId,
    pollingAddressId,
    toAddresses,
    ccAddresses,
    subject,
    message,
    attachments,
  },
  setState: {
    setPollingAddressId,
    setClassificationId,
    setToAddresses,
    setCcAddresses,
    setSubject,
    setMessage,
    openEmailAttachments,
  }
  
}) => {

  const { state: { staticData: {classifications}}} = useTeamQContext();
  const classificationOptions = convertToSelectOptions(classifications);
  return (
    <>
      <div className="form-group">
        <FormControl>
          <label htmlFor="new-case-polling-address">From</label>
          <Dropdown
            name="new-case-polling-addresst"
            onChange={(id: string): void => setPollingAddressId(id)}
            value={pollingAddressId}
          >
            {pollingAddresses.length !== 1 && <MenuItem value="">Select From Address</MenuItem>}
            {pollingAddresses.map((pollingAddress: PollingAddress, index: number) => (
              <MenuItem value={pollingAddress.emailAccountId} key={index}>
                {pollingAddress.emailAddress}
              </MenuItem>
            ))}
          </Dropdown>
        </FormControl>
      </div>
      <div className="form-group">
        <FormControl>
          <label htmlFor="new-case-classification">Classification</label>
          <Dropdown
            name="new-case-classification"
            onChange={(classificationId: string): void => setClassificationId(classificationId)}
            value={classificationId}
          >
            {classificationOptions.length !== 1 && <MenuItem value="">Select Classification</MenuItem>}
            {classificationOptions.map(({id, label}, index: number) => (
              <MenuItem value={id} key={index}>
                {label}
              </MenuItem>
            ))}
          </Dropdown>
        </FormControl>
      </div>
      <div className="email-input">
          <div className="content-container">
            <div className="flex-input to">
              <AddressesInput
                addresses={toAddresses}
                id="To-Addresses"
                label="To:"
                placeholder="Add To Address"
                setAddresses={setToAddresses}
              />
            </div>

            <div className="flex-input cc">
              <AddressesInput
                addresses={ccAddresses}
                id="CC-Addresses"
                label="CC:"
                placeholder="Add CC Address"
                setAddresses={setCcAddresses}
              />
            </div>
            <div className="flex-input">
              <label htmlFor="subject" style={{width: "4em", display: "inline-block"}}>Subject:</label>
              <input
                type="text"
                name="subject"
                id="subject"
                value={subject}
                onChange={(e): void => setSubject(e.target.value)}
                className="input-white"
              />
            </div>
            <div className="flex-input"  style={{margin: "3px 0"}}>
              <label>
                <button aria-label="Attach files" onClick={(): void => {
                    openEmailAttachments();
                  }}>
                  <i className="fas fa-paperclip"></i>
                </button>
              </label>
              <div className="attachments">
                {attachments.map((attachment: NewCaseAttachment, index: number) => (
                  <span key={index} className="attachment-pill">
                    {attachment.fileName}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex-input body">
              <textarea
                aria-label="email body"
                name="body"
                value={message}
                onChange={(e): void => setMessage(e.target.value)}
                className="input-white"
              ></textarea>
            </div>
          </div>
        </div>
    </>
  );
};
export default NewCaseForm;
